export default function ReferencesTestimonials() {
  return (
    <>
      <section id="references" style={{ scrollMarginTop: '80px' }} className="pt-20 pb-8 px-6 bg-gradient-to-br from-ocean-pale/30 to-sunset-warm/30 relative overflow-hidden">
        <div className="max-w-7xl mx-auto relative">
          <div className="text-center mb-2">
            <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-ocean-mid/10 to-sunset-coral/10 px-4 py-1 rounded-full mb-1 border border-ocean-mid/20">
              <i className="ri-star-line text-ocean-mid text-sm"></i>
              <span className="text-xs font-semibold text-ocean-mid uppercase tracking-wide">Trust & Experience</span>
            </div>
          </div>

          {/* References Content - 5 column grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-2">
            {/* TMF Group */}
            <div className="bg-white rounded-xl p-3 shadow-lg border border-ocean-mid/15">
              <div className="flex items-center justify-between mb-1.5">
                <div>
                  <h3 className="text-sm font-bold text-ocean-mid">TMF Netherlands B.V.</h3>
                  <p className="text-[9px] text-gray-600">Accounting Officer | Mar 2022 – Oct 2023</p>
                  <p className="text-[9px] text-gray-600">Amsterdam, Netherlands</p>
                  <p className="text-[9px] text-gray-600">Previously: TMF Turkey | 2015 – 2018</p>
                </div>
                <div className="w-8 h-8 bg-sunset-coral/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-global-line text-sunset-coral text-base"></i>
                </div>
              </div>
              <div className="text-gray-700 leading-relaxed space-y-1">
                <p className="text-[11px] italic">
                  &ldquo;Prior to relocating to TMF Netherlands, Beyhan Kilic was employed in Turkey by 90011 CPA Systems Limited (Turkey) starting 18 November 2015 until the date she relocated to the Netherlands.&rdquo;
                </p>
                <p className="text-[11px]">
                  Gained extensive experience in international financial administration, client account management, and US GAAP reporting.
                </p>
              </div>
            </div>

            {/* DuPont Reference */}
            <div className="bg-white rounded-xl p-3 shadow-lg border border-ocean-mid/15">
              <div className="flex items-center justify-between mb-1.5">
                <div>
                  <h3 className="text-sm font-bold text-ocean-mid">DuPont</h3>
                  <p className="text-[9px] text-gray-600">Accounting Specialist | 2018–2021</p>
                  <p className="text-[9px] text-gray-600">Istanbul, Turkey</p>
                </div>
                <div className="w-8 h-8 bg-ocean-mid/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-line text-ocean-mid text-base"></i>
                </div>
              </div>
              <div className="text-gray-700 leading-relaxed space-y-1">
                <p className="text-[11px] italic">
                  &ldquo;Her position required regular interaction with various departments and tax offices adherence to internal procedures and timelines.&rdquo;
                </p>
                <p className="text-[11px] italic">
                  &ldquo;Beyhan demonstrates a strong willingness to learn and exhibits a high level of curiosity. She consistently pays attention to deadlines and maintains a positive and energetic approach to her work.&rdquo;
                </p>
              </div>
            </div>

            {/* Pickles PR */}
            <div className="bg-white rounded-xl p-3 shadow-lg border border-ocean-mid/15">
              <div className="flex items-center justify-between mb-1.5">
                <div>
                  <h3 className="text-sm font-bold text-ocean-mid">Pickles PR</h3>
                  <p className="text-[9px] text-gray-600">Netherlands</p>
                </div>
                <div className="w-8 h-8 bg-ocean-teal/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-megaphone-line text-ocean-teal text-base"></i>
                </div>
              </div>
              <div className="text-gray-700 leading-relaxed space-y-1">
                <p className="text-[11px] italic">
                  &ldquo;We worked with Beyhan for a year and in that time she turned our company around, transforming our finances into something structured, organised and above all understandable. She was always cheerful and happy, never condescending.&rdquo;
                </p>
                <p className="text-[11px] italic">
                  &ldquo;Her attitude and approach not only made us trust her in all matters but also gave us confidence again in ourselves, and with that a renewed energy to reach out and to achieve more as a company.&rdquo;
                </p>
                <p className="text-[11px] italic">
                  &ldquo;Before Beyhan I never thought that finances could be an aspect of a company that is approached with a smile and with confidence: she gave us that.&rdquo;
                </p>
              </div>
            </div>

            {/* Clients */}
            <div className="bg-white rounded-xl p-3 shadow-lg border border-ocean-mid/15">
              <div className="flex items-center justify-between mb-1.5">
                <div>
                  <h3 className="text-sm font-bold text-ocean-mid">Clients</h3>
                  <p className="text-[9px] text-gray-600">Ongoing Projects</p>
                </div>
                <div className="w-8 h-8 bg-sunset-coral/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-sunset-coral text-base"></i>
                </div>
              </div>
              <div className="text-gray-700 leading-relaxed space-y-1">
                <p className="text-[11px]">
                  Currently providing professional financial administration services to clients worldwide.
                </p>
                <p className="text-[11px]">
                  Delivering on-site support in the Netherlands and remote financial support worldwide.
                </p>
                <p className="text-[11px]">
                  Supporting business growth through reliable financial oversight and efficient administration.
                </p>
                <p className="text-[11px]">
                  Building long-term partnerships based on trust, accuracy, and expertise.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
